export function getColorVariant({
  thread,
  role,
}: {
  thread: string;
  role: string;
}) {
  return thread === 'internal' || role === 'client' ? 'primary' : 'purple';
}
